import React from 'react';

import { SvgIcon } from '@mui/material';

const CashIcon = () => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 8C7 8.55228 6.55228 9 6 9C5.44772 9 5 8.55228 5 8C5 7.44772 5.44772 7 6 7C6.55228 7 7 7.44772 7 8Z"
        fill="#2F313F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 11.5C9 9.8 10.3 8.5 12 8.5C13.7 8.5 15 9.8 15 11.5V12.5C15 14.2 13.7 15.5 12 15.5C10.3 15.5 9 14.2 9 12.5V11.5ZM12 13.5C12.6 13.5 13 13.1 13 12.5V11.5C13 10.9 12.6 10.5 12 10.5C11.4 10.5 11 10.9 11 11.5V12.5C11 13.1 11.4 13.5 12 13.5Z"
        fill="#2F313F"
      />
      <path
        d="M18 15C17.4 15 17 15.4 17 16C17 16.6 17.4 17 18 17C18.6 17 19 16.6 19 16C19 15.4 18.6 15 18 15Z"
        fill="#2F313F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6 18.9C12.9 19.5 14.3 20 16 20C19.2 20 21.4 18.9 21.4 18.9C21.8 18.7 22 18.4 22 18V6.7C22 6.3 21.8 5.8 21.4 5.5C21 5.2 20.5 5.1 20 5.3C19.3 5.6 17.9 6 16 6C14.9493 6 14.0293 5.6734 13.0815 5.33695C12.8566 5.25711 12.6301 5.17672 12.4 5.1C11.1 4.5 9.7 4 8 4C4.8 4 2.6 5.1 2.6 5.1C2.2 5.3 2 5.6 2 6V17.3C2 17.7 2.2 18.2 2.6 18.5C3 18.8 3.5 18.9 4 18.7C4.7 18.4 6.1 18 8 18C9.05067 18 9.97071 18.3266 10.9185 18.663C11.1434 18.7429 11.3699 18.8233 11.6 18.9ZM12.4 17.1C11.1 16.5 9.7 16 8 16C6.4 16 5 16.3 4 16.6V6.7C4.7 6.4 6.2 6 8 6C9.05067 6 9.97071 6.3266 10.9185 6.66305C11.1434 6.74289 11.3699 6.82328 11.6 6.9C12.9 7.5 14.3 8 16 8C17.6 8 19 7.7 20 7.4V17.3C19.3 17.6 17.8 18 16 18C14.7 18 13.6 17.6 12.4 17.1Z"
        fill="#2F313F"
      />
    </SvgIcon>
  );
};

export default CashIcon;
